import { useWallet } from '@solana/wallet-adapter-react';
import { WalletDisconnectButton, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { FC } from 'react';

const Navigation: FC = () => {
    const { wallet } = useWallet();

    return (
        <div>
        <nav>
            <h1> </h1>
            <div>
                <WalletMultiButton />
                {wallet && <WalletDisconnectButton />}
            </div>
        </nav>
            {/* <div>
                {publicKey && <Form />}
            </div> */}

        </div>
    );
};

export default Navigation;
